import React from 'react';
import '../../assets/css/loader.css';

const Loader = () => (
  <div className="modal">
    <div className="modal-content">
      <div className="container-md p-loader">
        <div className="loader" />
      </div>
    </div>
  </div>
);

export default Loader;
